import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { SEMANTIC_SURFACE } from "../../utils/iconMap"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()
  const T = SEMANTIC_SURFACE.toast

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: T.success,
          error: T.error,
          warning: T.warning,
          info: T.info,
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
